import React from 'react';
import {Switch, Route} from "react-router-dom";
import Login from '../modules/administration/Login'
import Home from "../modules/Home";
import Signup from "../modules/administration/Signup";
import Session from "../helpers/Session";
import Redirect from "../helpers/Redirect";
import ValidLogin from "../components/ValidLogin";
import Pqrs from "../modules/pqr/Pqrs";
import RecoverPassword from "../modules/administration/RecoverPassword";
import UpdateProfile from "../modules/administration/UpdateProfile";
import ChangePassword from "../modules/administration/ChangePassword";
import Donations from "../modules/donations/Donations";
import DashBoard from "../components/DashBoard";
import Consumptions from "../modules/consumptions/Consumptions";
import Invoices from "../modules/invoices/Invoices";
import Payments from "../modules/payments/Payments";
import Autogenerator from "../modules/autogenerator/Autogenerator";
import Proceedings from "../modules/proceedings/Proceedings";
import Suspensions from "../modules/suspensions/Suspensions";
import CuentaNuevaList from "../modules/cuenta-nueva/CuentaNuevaList";
import CuentaNuevaForm from "../modules/cuenta-nueva/CuentaNuevaForm";
import DocumentacionSolicitud from "../modules/cuenta-nueva/DocumentacionSolicitud";
import GrandesClientes from "../modules/grandes-clientes/GrandesClientes";
import DigitalInvoiceFormCreate from '../modules/digital-invoice/DigitalInvoiceFormCreate';
import DigitalInvoiceFormModify from '../modules/digital-invoice/DigitalInvoiceFormModify';
import DigitalInvoiceFormDelete from '../modules/digital-invoice/DigitalInvoiceFormDelete';
import InscripcionProveedores from '../modules/inscripcion-proveedores/InscripcionProveedores';
import ListarInscripcionProveedores from '../modules/inscripcion-proveedores/ListarInscripcionProveedores';

const RouterApp = () => {
    return (
        <Switch>

            <Route exact path="/login" render={() => <ValidLogin path={<Home/>}/>}/>

            <Route exact path='/signup'>
                <Signup/>
            </Route>

            <Route exact path='/recover-password'>
                <RecoverPassword/>
            </Route>

            <Route exact path="/accounts" render={() => <ValidLogin path={<Home/>}/>}/>
            <Route exact path="/menu" render={() => <ValidLogin path={<DashBoard/>}/>}/>
            <Route exact path="/list-pqrs" render={() => <ValidLogin path={<Pqrs/>}/>}/>
            <Route exact path="/create-digital-invoice" render={() => <ValidLogin path={<DigitalInvoiceFormCreate/>}/>}/>
            <Route exact path="/modify-digital-invoice" render={() => <ValidLogin path={<DigitalInvoiceFormModify/>}/>}/>
            <Route exact path="/delete-digital-invoice" render={() => <ValidLogin path={<DigitalInvoiceFormDelete/>}/>}/>
            <Route exact path="/consumptions" render={() => <ValidLogin path={<Consumptions/>}/>}/>
            <Route exact path="/invoices" render={() => <ValidLogin path={<Invoices/>}/>}/>
            <Route exact path="/payments" render={() => <ValidLogin path={<Payments/>}/>}/>
            <Route exact path="/autogenerator" render={() => <ValidLogin path={<Autogenerator/>}/>}/>
            <Route exact path="/proceedings" render={() => <ValidLogin path={<Proceedings/>}/>}/>
            <Route exact path="/suspensions" render={() => <ValidLogin path={<Suspensions/>}/>}/>
            <Route exact path="/donations" render={() => <ValidLogin path={<Donations/>}/>}/>
            <Route exact path="/update-profile" render={() => <ValidLogin path={<UpdateProfile/>}/>}/>
            <Route exact path="/change-password" render={() => <ValidLogin path={<ChangePassword/>}/>}/>
            <Route exact path="/new-account-list" render={() => <ValidLogin redirect={true} path={<CuentaNuevaList/>}/>}/>
            <Route exact path="/new-account/:tipoUsuario" render={() => <ValidLogin path={<CuentaNuevaForm/>}/>}/>
            <Route exact path="/new-account/documentation/:solicitudID" render={() => <ValidLogin redirect={true} path={<DocumentacionSolicitud/>}/>}/>
            <Route exact path="/big-clients" render={() => <ValidLogin path={<GrandesClientes/>}/>}/>
            <Route exact path="/provider-registration" render={() => <ValidLogin redirect={true} path={<InscripcionProveedores/>}/>}/>
            <Route exact path="/provider-registration-list" render={() => <ValidLogin redirect={true} path={<ListarInscripcionProveedores/>}/>}/>

            <Route exact path="/logout" render={() => {
                Session.logout();
                return <Redirect url='/'/>;
            }}/>

            <Route path='/'>
                <Login/>
            </Route>

        </Switch>
    );
}
export default RouterApp